// English
export default {
  HELPER: {
    position:
      'Browse through a list of company positions and easily manage them using this interface. The page displays the names of each position for quick reference and organization. You can view all existing positions at a glance and perform actions such as creating new positions or updating existing ones.',
  },
}
